import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'assign',
  pure: true
})
export class AssignPipe implements PipeTransform {
  transform(target: Object, source: Object): any {
    return {
      ...target,
      ...source
    };
  }
}
